import { StyledGrid, lightColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledGridWrapper = styled(StyledGrid)`
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledSocialImageWrapper = styled.figure`
  max-width: 51.3rem;
  height: auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey[200]};
  overflow: hidden;

  img {
    width: 100%;
    max-height: 290px;
    height: auto;
    display: block;
    object-fit: contain;
  }

  figcaption {
    padding: 1rem;
    text-align: left;
    background: ${({ theme }) => theme.colors.grey[200]};
  }

  h3 {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    color: ${lightColors.paragraph};
    margin: 0;
    margin-bottom: 0.5rem;
  }

  p {
    color: ${lightColors.paragraph};
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
    margin: 0;
  }
`;

export const StyledSocialButtonsWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.9rem;

  button[data-btn='copy-link'] {
    svg {
      width: 2rem;
      height: 1.9rem;
    }
  }
`;
